var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgErrorLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 153 123",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M148.376 95.081c-6.057-10.494-12.114-20.988-18.178-31.482-8.132-14.077-16.256-28.162-24.388-42.24-2.115-3.662-4.23-7.333-6.352-10.996C95.668 3.835 88.844.005 81.215 1.226c-5.14.822-9.465 3.974-12.13 8.395-4.78 8.275-9.552 16.55-14.332 24.826-8.396 14.548-16.79 29.088-25.194 43.636-2.833 4.908-5.666 9.808-8.499 14.716-2.442 4.237-4.652 8.371-4.126 13.518.926 9.05 8.54 15.577 17.509 15.665 3.623.04 7.254 0 10.877 0h86.569c6.185 0 11.899-1.668 15.817-6.831 4.605-6.073 4.357-13.67.662-20.07h.008Z",
  stroke: "url(#error-location_svg__a)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M85.484 30.45c-2.282-.025-4.652-.184-6.815.662a9.563 9.563 0 0 0-5.785 6.679c-.599 2.578-.072 5.57.08 8.172.27 4.692.542 9.392.822 14.085l.742 12.688c.31 5.323 3.798 10.015 9.544 10.015 5.459-.223 9.153-4.237 9.52-9.568.224-3.264.383-6.536.567-9.8.447-7.629 1.157-15.29 1.333-22.927.135-5.81-4.334-9.959-10.008-10.007Z",
  stroke: "url(#error-location_svg__b)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M93.752 96.621c-.4-5.1-4.39-9.273-9.68-9.297-5.283-.016-9.72 4.445-9.72 9.72s4.437 9.72 9.72 9.72 9.28-4.206 9.68-9.297c.024-.136.04-.271.04-.423a2.34 2.34 0 0 0-.032-.423h-.008Z",
  stroke: "url(#error-location_svg__c)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M58.72 47.067c0 15.974-28.86 47.79-28.86 47.79S1 63.049 1 47.067s12.913-28.924 28.852-28.924c15.94 0 28.86 12.95 28.86 28.924h.008Z",
  fill: "#fff",
  stroke: "url(#error-location_svg__d)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.852 60.307c7.465 0 13.517-6.065 13.517-13.547 0-7.481-6.052-13.546-13.517-13.546s-13.517 6.065-13.517 13.547c0 7.481 6.052 13.546 13.517 13.546Z",
  stroke: "url(#error-location_svg__e)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-location_svg__a",
  x1: -2.144,
  y1: 106.541,
  x2: 151.936,
  y2: 106.541,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-location_svg__b",
  x1: -2.144,
  y1: 106.541,
  x2: 151.936,
  y2: 106.541,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-location_svg__c",
  x1: -2.144,
  y1: 106.541,
  x2: 151.936,
  y2: 106.541,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-location_svg__d",
  x1: 1,
  y1: 56.5,
  x2: 155.856,
  y2: 56.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-location_svg__e",
  x1: 2.356,
  y1: 47,
  x2: 155.856,
  y2: 47,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})))));
export { SvgErrorLocation as ReactComponent };
export default __webpack_public_path__ + "/assets/ef14337dc3ea31b4adf5c59becea5ecb.svg";